// Session timer modal component
import React from "react";
import config from "../../config/config";

class SessionTimeoutModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = { count: config.SESSION_NOTIFICATION_TIMEOUT };
    this.endTimer = null;
  }

  componentDidMount() {
    this.startTimer();
  }

  componentWillUnmount() {
    clearTimeout(this.endTimer);
  }

  closeModal = () => {
    clearTimeout(this.endTimer);
    const { count } = this.state;
    const { onCancleSession } = this.props;
    onCancleSession(count);
  };

  startTimer = () => {
    const { count } = this.state;
    const { onCancleSession } = this.props;
    let value = count;
    this.endTimer = setTimeout(() => {
      if (count > 0) {
        value -= 1;
        this.setState({ count: value });
        this.startTimer();
      }
      if (count === 0) {
        onCancleSession(0);
      }
    }, 1000);
  };

  onClickOk = () => {
    clearTimeout(this.endTimer);
    const { onResetSession } = this.props;
    onResetSession();
  };

  render() {
    const { count } = this.state;

    return (
      <>
        <div id="confirm-modal" className="modal-custom session">
          <div className="modal-title-custom mb-0">
            <h2 className="text-white mb-0 me-auto modal-title">Session Expiration Notification</h2>
            <div className="close-icon text-end">
              <button
                type="button"
                className="close"
                aria-label="close modal"
                data-dismiss="modal"
                onClick={this.closeModal}
              >
                <span aria-hidden="true">
                  <i className="fa fa-times text-red" />
                </span>
              </button>
            </div>
          </div>
          <div className="rotation-option" style={{ marginTop: "30px" }}>
            <div className="form-group">
              <div style={{ color: "white" }}>
                Your session will get expired in &nbsp;
                <b>{count}</b>
                &nbsp; seconds.
              </div>
            </div>
          </div>
          <div className="d-flex justify-content-center">
            <button type="submit" className="btn btn-primary btn-auth" onClick={this.onClickOk}>
              Refresh Session
            </button>
          </div>
        </div>
      </>
    );
  }
}

export default SessionTimeoutModal;
